import { render, staticRenderFns } from "./setRouterRemoteModal.vue?vue&type=template&id=49fa4586&scoped=true&"
import script from "./setRouterRemoteModal.vue?vue&type=script&lang=js&"
export * from "./setRouterRemoteModal.vue?vue&type=script&lang=js&"
import style0 from "./setRouterRemoteModal.vue?vue&type=style&index=0&id=49fa4586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa4586",
  null
  
)

component.options.__file = "setRouterRemoteModal.vue"
export default component.exports